import cn from "classnames";
import type {
  ComponentPropsWithRef,
  FC,
  PropsWithChildren,
  ReactNode,
} from "react";
import styles from "./SidebarMenu.module.css";

interface SidebarMenuProps extends ComponentPropsWithRef<"ul"> {
  children: ReactNode;
}

const SidebarMenu: FC<SidebarMenuProps> = ({ className, ...rest }) => {
  return <ul className={cn(styles.menu, className)} {...rest} />;
};

interface ItemProps extends ComponentPropsWithRef<"button"> {
  active?: boolean;
}

const SidebarMenuItem: FC<ItemProps> = ({ active, className, ...rest }) => {
  return (
    <li>
      <button
        type="button"
        className={cn(styles.item, active && styles.active, className)}
        {...rest}
      />
    </li>
  );
};

interface GroupProps extends PropsWithChildren {
  label: ReactNode;
  className?: string;
}

const SidebarMenuGroup: FC<GroupProps> = ({ label, children, className }) => {
  return (
    <li className={cn(styles.group, className)}>
      <span className={styles.groupLabel}>{label}</span>
      <ul className={styles.children}>{children}</ul>
    </li>
  );
};

const SidebarMenuNamespace = Object.assign(SidebarMenu, {
  Item: SidebarMenuItem,
  Group: SidebarMenuGroup,
});

export { SidebarMenuNamespace as SidebarMenu };
